
import { Component, Emit, Prop, VModel, Vue } from "vue-property-decorator";

@Component
export default class TextareaBox extends Vue {
  @VModel({ type: String }) currText!: string;
  @Prop(String) readonly title!: string;
  @Prop(String) readonly submitBtnText!: string;
  @Prop({ type: String, default: "" }) readonly placeholder!: string;
  @Prop({ type: String, default: "" }) readonly titleTip!: string;
  @Prop({ type: String, default: "" }) readonly headerBtnText!: string;
  @Prop({ type: String, default: "" }) readonly headerBtnTips!: string;
  @Prop({ type: Boolean, default: false }) readonly submiting!: boolean;

  @Emit("click-header-btn")
  onClickHeaderBtn() {}

  @Emit("submit")
  onSubmit() {}
}
